import {Sprite, Texture} from 'pixi.js';

export interface CachedTexture {
    texture?: Texture;
    position?: { x: number; y: number; };
    getTexture: () => Texture;
}

export class CachedSprite extends Sprite {

    protected _cachedTexture: CachedTexture;

    constructor(cachedTexture: CachedTexture) {
        super();

        this._cachedTexture = cachedTexture;

        this.on('added', this.onAdded, this);
    }

    protected onAdded(): void {
        if (this.texture === Texture.EMPTY) {
            this.texture = this._cachedTexture.getTexture();

            this.x = this._cachedTexture.position!.x;
            this.y = this._cachedTexture.position!.y;
        }
    }

    public get cachedTexture(): CachedTexture {
        return this._cachedTexture;
    }

    public set cachedTexture(value: CachedTexture) {
        this._cachedTexture = value;
    }

}